<template>
  <div class="compound public-content">
    <div class="breadcrumb">页码管理</div>
    <div style="overflow:hidden" class="breadcrumb">
      <el-button @click="$router.push('/createPagnination')" v-permission="'pts:admin:page:add'" type="primary" style="margin:10px 50px 10px 0;float:right"
        round>新建页码</el-button>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" border>
          <el-table-column label="页码名称" prop="pageName"></el-table-column>
          <el-table-column label="每P页码数" prop="pageNumber"></el-table-column>
          <el-table-column label="页码起始页" prop="startPage"></el-table-column>
          <el-table-column label="页码参数">
            <template slot-scope="scope">
              <p v-for="(item,index) in scope.row.pageNumberDetailList" :key='item.id'>
                页码{{index+1}}：{{(item.portrait==='top'?'距上':'距下')+':'+item.portraitParam+'mm,'+(item.transverse==='left'?'距左':'距右')+':'+item.transverseParam+'mm'}}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="页码样式" prop="pageNumberType.typeName"></el-table-column>
          <el-table-column label="预览">
            <template slot-scope="scope">
              <span :style="'font-size:'+scope.row.fontSize+'px'">{{scope.row.pageNumberType.preview}}</span>
            </template>
          </el-table-column>
          <el-table-column label="字号" prop="fontSize"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="color-blue" v-permission="'pts:admin:page:update'"
                @click="$router.push({path:'/editpagination',query:{id:scope.row.id,relation:scope.row.relation}})">编辑<br></span>
              <span class="color-blue" v-permission="'pts:admin:page:delete'" @click="deleteId=scope.row.id,deleteDialog=true">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该页码吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deletePage(deleteId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import VPagination from '@/components/Pagination/index'
import { pageNumberGetPageNumberList, pageNumberDelete } from '@/api/pms'
export default {
  name: 'compound',
  components: {
    VPagination
  },
  data () {
    return {
      deleteDialog: false,
      deleteId: '',
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      tableData: [],
      searchPageNumberVo: {
        page: 1,
        pageNumber: ''
      }
    }
  },
  created () {
    this.onSubmit()
  },
  methods: {
    deletePage (id) {
      pageNumberDelete(id).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.onSubmit()
          this.deleteDialog = false
        }
      })
    },
    onSubmit () {
      pageNumberGetPageNumberList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, searchPageNumberVo: this.searchPageNumberVo }).then(res => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.onSubmit(this.queryInfo)
          }
          this.tableData = res.data.data.records
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
 <style scoped lang="less">
.compound {
  .add-category {
    justify-content: space-between;
  }
  .keywords {
    display: flex;
    justify-content: space-around;
    // width: 750px;
    align-items: center;
    .el-input {
      width: 180px;
    }
  }
}
</style>
